<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import 'multi-range-slider-vue/MultiRangeSliderBarOnly.css'
import Multiselect from 'vue-multiselect'
import { Helper } from '@/mixin/helper'
import { required, requiredIf, minLength, maxLength } from 'vuelidate/lib/validators'

import { GET_USER, GET_USERS, GET_USER_GROUPS, UPDATE_USER } from '@/services/api/master/user'
import { GET_EMPLOYEES } from '@/services/api/master/employees'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Data Pengguna',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  mixins: [Helper],
  apollo: {
    users: {
      query: GET_USERS,
      result({ data, loading }) {
        if (!loading) {
          this.totalRows = data.users.users.length
          this.filteredItems = data.users.users
        }
      },
    },
    ugroups: {
      query: GET_USER_GROUPS,
      result({ data, loading }) {
        if (!loading) {
          this.ugroups.ugroups = data.ugroups.ugroups
        }
      },
    },
    employees: {
      query: GET_EMPLOYEES,
    },
  },
  data() {
    return {
      phaseOneShow: false,
      testLang: this.$i18n.t('global.search'),
      filterSelected: [],
      selectAll: false,
      users: {
        users: [],
      },
      deleteUser: [],
      employees: {
        employees: [],
      },
      ugroups: {
        ugroups: [],
      },
      form: {
        userType: 'karyawan',
        userId: null,
        fullname: null,
        password: null,
        isEmployee: false,
        groups: null,
        oldGroups: null,
      },
      filterMonth: '',
      // selected: [],
      position: null,
      department: null,
      userGroup: null,
      userName: null,
      userGroupName: null,
      fav: null,
      isAddFavorit: false,
      addFavorit: null,
      showModal: false,
      show_model: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'name',
      sortDesc: false,
      barMinValueSpeed: 1,
      barMaxValueSpeed: 160,
      barMinValueDegree: 1,
      barMaxValueDegree: 100,
      barMinValueTemp: 1,
      barMaxValueTemp: 100,
      isEdit: false,
      showPasswordIcon: 'icon-outline_eye-off-2',
      isPasswordShow: false,
      show: [
        { key: 'email', label: 'Email' },
        { key: 'fullname', label: 'Nama Karyawan' },
        { key: 'Department', label: 'Departemen' },
        { key: 'position', label: 'Posisi' },
        { key: 'groupName', label: 'Grup Pengguna' },
        { key: 'lastLogin', label: 'Waktu Masuk' },
      ],
      listUser: [
        {
          key: 'check',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'email',
          label: 'Email',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'fullname',
          label: this.$i18n.t('master.list.user.fullname'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'department',
          label: this.$i18n.t('master.list.user.department'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'position',
          label: this.$i18n.t('master.list.user.position'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'groupName',
          label: this.$i18n.t('master.list.user.group'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'lastLogin',
          label: this.$i18n.t('master.list.user.lastLogin'),
          thClass: 'mc-table--50',
          sortable: true,
        },
      ],
      itemModal: {},
      filteredItems: [],
    }
  },
  validations: {
    form: {
      fullname: { required },
      password: {
        required: requiredIf(function () {
          return !this.isEdit
        }),
        minLength: minLength(4),
        maxLength: maxLength(50),
      },
      username: { required },
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.users.users.length
    },
    title() {
      return this.$t('master.pengguna')
    },
    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        var result = this.show_model.map((a) => a.key)

        return this.listUser.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.listUser
      }
    },
    canLoginUsers() {
      return this.users.users.filter(function (item) {
        return item.canLogin
      })
    },
    cannotLoginUsers() {
      var users = this.employees.employees.filter(function (item) {
        return !item.canLogin
      })

      var department = users.map(function (item) {
        return item.position ? item.position.departmentName : 'No Department'
      })
      department = [...new Set(department)]

      var res = []
      for (let i = 0; i < department.length; i++) {
        var usersDepartment = []
        users.forEach(function (item) {
          var userDepartment = item.position ? item.position.departmentName : 'No Department'
          if (department[i] == userDepartment) {
            usersDepartment.push(item)
          }
        })

        res.push({
          department: department[i],
          users: usersDepartment,
        })
      }

      return res
    },
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    toggleAll(event) {
      var checked = event.target.checked
      var userId = this.getUserId()
      this.filterSelected = []
      if (checked) {
        this.filterSelected = this.users.users.map((item) => item.userId)
        let index = this.filterSelected.indexOf(userId)
        this.filterSelected.splice(index, 1)
      } else {
        this.filterSelected = []
      }
    },
    checkTable(event) {
      if (event.target.checked) {
        this.filterSelected.push(parseInt(event.target.value))
        if (this.filterSelected.length == this.users.users.length) {
          this.selectAll = true
        }
      } else {
        this.selectAll = false
        var index = this.filterSelected.indexOf(parseInt(event.target.value))
        if (index !== -1) {
          this.filterSelected.splice(index, 1)
        }
      }
    },
    openModalDelete() {
      for (let i = 0; i < this.filterSelected.length; i++) {
        this.$apollo
          .query({
            query: GET_USER,
            variables: {
              input: {
                userId: parseInt(this.filterSelected[i]),
              },
            },
          })
          .then((res) => {
            var isSuccessful = res.data.user.isSuccessful
            if (isSuccessful) {
              this.deleteUser.push(res.data.user.user)
            }
          })
      }
      this.$bvModal.show('modal-delete-user')
    },
    add(param, obj) {
      this.users.users.push(obj)
    },
    toDelete(bvModalEvent) {
      bvModalEvent.preventDefault()
      let promises = []

      for (let i = 0; i < this.filterSelected.length; i++) {
        var input = {
          userId: this.filterSelected[i],
          oldData: {
            canLogin: true,
            password: '',
          },
          newData: {
            canLogin: false,
            password: '',
          },
        }

        promises.push(
          this.$apollo.mutate({
            mutation: UPDATE_USER,
            variables: {
              input: input,
            },
          })
        )
      }

      Promise.all(promises).then(() => {
        this.$apollo.queries.users.refetch()
        this.$toast.success(`Data berhasil terhapus`)
        this.clearCheck()
        this.$bvModal.hide('modal-delete-user')
      })
    },

    resetModal() {
      this.$v.$reset()
      this.form = {
        userType: 'karyawan',
        userId: null,
        fullname: null,
        password: null,
        isEmployee: false,
        email: null,
        username: null,
        usernameOld: null,
        groups: null,
        groupsOld: null,
      }
      this.showPasswordIcon = 'icon-outline_eye-off-2'
      this.isPasswordShow = false
      this.deleteUser = []
    },
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault()

      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }
      if (this.form.email == '' || this.form.email == null) {
        return this.$toast.error(`Email tidak boleh kosong.`)
      }

      if (this.form.username == '' || this.form.username == null) {
        return this.$toast.error(`Username tidak boleh kosong.`)
      }

      if (this.form.password == '' || this.form.password == null) {
        return this.$toast.error(`Password tidak boleh kosong.`)
      }

      var passwordChange = {}
      if (this.form.password != '' && this.form.password != null) {
        passwordChange = { password: this.form.password }
      }

      var oldUsername = this.form.usernameOld ? this.form.usernameOld : null

      var newGroups = this.form.groups ? this.form.groups.id : []
      var oldGroups = this.form.groupsOld ? this.form.groupsOld.id : []

      var input = {
        userId: this.form.userId,
        oldData: {
          username: oldUsername,
          groups: oldGroups,
          canLogin: false,
          ...passwordChange,
        },
        newData: {
          username: this.form.username,
          groups: newGroups,
          canLogin: true,
          ...passwordChange,
        },
      }

      this.$apollo
        .mutate({
          mutation: UPDATE_USER,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (response.data.updateUser.isSuccessful) {
            this.$apollo.queries.users.refetch()
            this.$toast.success(`Data berhasil tersimpan`)
            this.$bvModal.hide('modal-form-user')
          } else {
            return this.$toast.error(`Terdapat kesalahan pada sistem.`)
          }
        })
    },
    handleSubmit() {
      this.$nextTick(() => {
        this.$bvModal.hide('modal-form-user')
      })
    },
    onRowClicked(item) {
      this.isEdit = true

      this.form.userType = item.userType
      this.form.userId = item.userId
      this.form.fullname = item.fullname
      this.form.email = item.email
      this.form.username = item.username
      this.form.usernameOld = item.username
      this.form.password = null
      this.form.isEmployee = item.isEmployee
      this.form.groups = item.groups[0]
      this.form.groupsOld = item.groups[0]

      this.$bvModal.show('modal-form-user')
    },
    addUser() {
      this.isEdit = false
      this.form = {
        userType: 'karyawan',
        userId: null,
        fullname: null,
        password: null,
        isEmployee: false,
        email: null,
        username: null,
        usernameOld: null,
        groupsOld: [],
      }
    },
    changeGroup(item) {
      var selectedValue = this.$refs.groupOptions.value
      this.form.groups = item
      console.log(selectedValue, this.form.groups)
    },
    showPassword() {
      if (this.isPasswordShow) {
        this.showPasswordIcon = 'icon-outline_eye-off-2'
        this.isPasswordShow = false
      } else {
        this.showPasswordIcon = 'icon-outline_eye'
        this.isPasswordShow = true
      }
    },
    clearCheck() {
      this.filterSelected = []
      this.selectAll = false
    },
    setUsernameDefault(){
      this.form.username = this.form.email
      this.form.password = ''
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />

      <p class="mb-4">{{ $t('master.textPengguna') }}</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            variant="outline-primary"
            @click="$router.push({ name: 'Master Home Page' })"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t('global.back') }}
          </b-button>

          <b-dropdown
            right
            variant="primary"
            menu-class="dropdown-menu-end"
            class="mc-btn-download"
            v-if="phaseOneShow"
          >
            <!-- For Phase 1 Download will be disabled -->
            <template v-slot:button-content>
              Unduh <i class="mdi mdi-chevron-down ps-2"></i>
            </template>
            <b-dropdown-item
              ><i class="bx bx-book-content align-middle pe-1"></i> Unduh Tabel
              Excel</b-dropdown-item
            >
            <b-dropdown-item
              ><i class="bx bx-book-content align-middle pe-1"></i> Unduh Tabel PDF</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>

      <!-- For Phase 1 Filter will be disabled -->
      <div class="row mb-3">
        <div class="col-md-12">
          <div class="mc-table-filter text-end">
            <a
              v-b-modal.modal-filter
              class="popup-form btn btn-outline-primary mx-2 mc-btn-filter"
              href="javascript: void(0);"
              v-if="phaseOneShow"
            >
              <i class="mc-fa icon-outline_filter"></i> Filter
            </a>
            <b-modal
              class="mc-modal"
              id="modal-filter"
              title="Filter"
              size="lg"
              centered
              scrollable
              v-if="phaseOneShow"
            >
              <div class="card-body mc-modal__filter">
                <form>
                  <div class="mc-modal__filter-item">
                    <label class="mt-3">Posisi</label>
                    <multiselect
                      v-model="position"
                      :options="['Operational', 'Sales/Marketing', 'Engineering', 'Logistic']"
                      :multiple="true"
                      placeholder="Posisi"
                    >
                    </multiselect>
                  </div>
                  <div class="mc-modal__filter-item">
                    <label>Departemen</label>
                    <multiselect
                      v-model="department"
                      :options="[
                        'Sales & Delivery',
                        'Sales/Marketing',
                        'IT',
                        'Logistic',
                        'Product',
                        'Engineering',
                      ]"
                      placeholder="Pilih Departemen"
                    >
                    </multiselect>
                  </div>
                  <div class="mc-modal__filter-item">
                    <label>Grup Pengguna</label>
                    <multiselect
                      v-model="userGroup"
                      :options="['System Administrator', 'Jabodetabek', 'Malang', 'Tapal Kuda']"
                      placeholder="Pilih Grup Pengguna"
                    >
                    </multiselect>
                  </div>
                </form>
              </div>
              <template #modal-footer="{ cancel }">
                <b-row class="mc-modal__filter-footer">
                  <b-col sm="12" md="8" class="mc-modal__filter-footer-fav">
                    <b-row>
                      <b-col md="6">
                        <b-form-group
                          v-if="!isAddFavorit"
                          id="favorit-label-modal"
                          label="Favorit"
                          label-for="favorit-modal"
                        >
                          <multiselect
                            v-model="fav"
                            :options="['Semua Status', 'Status Aktif', 'Status Nonaktif']"
                            :show-labels="false"
                          ></multiselect>
                        </b-form-group>
                        <b-form-group
                          v-if="isAddFavorit"
                          id="favorit-add-label-modal"
                          label="Favorit"
                          label-for="favorit-modal-add"
                        >
                          <b-form-input
                            id="favorit-modal-add"
                            v-model="addFavorit"
                            placeholder="Nama Favorit"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-button
                          v-if="!isAddFavorit"
                          variant="outline-primary"
                          class="mt-4"
                          @click="isAddFavorit = !isAddFavorit"
                        >
                          <i class="mdi mdi-file-plus-outline"></i> Buat Favorit Baru
                        </b-button>
                        <b-button v-if="isAddFavorit" variant="outline-primary" class="mt-4">
                          <i class="fas fa-save"></i> Simpan Sebagai Favorit
                        </b-button>
                        <i
                          v-if="isAddFavorit"
                          class="fas fa-trash text-danger text-lg mt-4 mx-2"
                          @click="isAddFavorit = !isAddFavorit"
                        ></i>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col sm="12" md="4" class="mc-modal__filter-footer-btn">
                    <b-button variant="outline-primary" @click="cancel()" class="me-3">
                      Close
                    </b-button>
                    <b-button variant="primary"> Terapkan </b-button>
                  </b-col>
                </b-row>
              </template>
            </b-modal>
            <b-button
              v-if="filterSelected.length"
              @click="openModalDelete"
              variant="outline-danger"
              class="mx-2"
            >
              <i class="mc-fa icon-outline_trash"></i> {{ $t('global.delete') }}
            </b-button>
            <a
              v-b-modal.modal-form-user
              class="popup-form btn btn-primary"
              href="javascript: void(0);"
              @click="addUser"
            >
              <i class="mc-fa icon-outline_plus"></i>
              {{ $t('global.addField') }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4 col-md-4 mc-row-check-wrapper">
            <h6 v-if="filterSelected.length" class="mc-row-check">
              <span class="badge btn-success">{{ filterSelected.length }}</span>
              {{ $t('global.selectedRows') }}
              <a class="color-primary" @click="clearCheck">{{ $t('global.action.clearAll') }}</a>
            </h6>
          </div>

          <!-- Search -->
          <div class="ol-sm-8 col-md-8 d-flex flex-row-reverse mc-table-view-wrapper">
            <div class="mc-table-view">
              <p class="mc-label">{{ $t('global.shown') }}</p>
              <multiselect
                v-model="show_model"
                :options="show"
                :multiple="true"
                :placeholder="$t('global.object.allColumn')"
                track-by="label"
                label="label"
              >
                <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
              </multiselect>
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label class="d-inline-flex align-items-center mc-table-view__search">
                  <i class="mc-fa fas fa-search"></i>
                  <b-form-input
                    v-model="filter"
                    type="search"
                    :placeholder="$t('global.search') + '...'"
                    class="ms-2"
                  >
                  </b-form-input>
                </label>
              </div>
            </div>
          </div>
          <!-- End search -->
        </div>

        <!-- Table -->
        <div class="table-responsive my-3 border border-1">
          <b-table
            small
            show-empty
            :fields="visibleFields"
            :items="canLoginUsers"
            sort-by="fullname"
            class="datatables"
            responsive="lg"
            empty-table
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            :empty-text="$t('global.emptyTable')"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
            :busy="$apollo.queries.users.loading"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>

            <template #head(check)>
              <div class="form-check">
                <input
                  class="form-check-input me-1"
                  type="checkbox"
                  value="all"
                  v-model="selectAll"
                  @input="toggleAll"
                />
              </div>
            </template>

            <template #cell(check)="data">
              <div class="form-check">
                <b-form-checkbox
                  :value="data.item.userId"
                  v-model="filterSelected"
                  @input="checkTable"
                  :disabled="cannotDelete(data.item.userId)"
                ></b-form-checkbox>
              </div>
            </template>

            <template #cell(email)="data">
              <strong class="text-primary" @click="onRowClicked(data.item)">
                {{ data.item.email }}
              </strong>
            </template>

            <template #cell(groupName)="data">
              {{ data.item.groups.map((entry) => entry.name).join(', ') }}
            </template>

            <template #cell(department)="data">
              {{ data.item.position ? data.item.position.departmentName : 'No Department' }}
            </template>

            <template #cell(position)="data">
              {{ data.item.position ? data.item.position.name : 'No Position' }}
            </template>

            <template #cell(lastLogin)="data">
              <p class="my-0">
                {{ data.item.lastLogin ? momentDateShortMonth(data.item.lastLogin) : '-' }}
              </p>
              <p class="text-muted my-0">
                {{ data.item.lastLogin ? momentTime(data.item.lastLogin) : '' }}
              </p>
            </template>
          </b-table>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                {{ $t('global.show') }}
                <b-form-select
                  class="form-select form-select-sm"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                >
                </b-form-select>
                {{ $t('global.text.entries') }}.
                <p>
                  {{ $t('global.show') }}&nbsp;<strong>{{
                    filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0
                  }}</strong
                  >&nbsp;{{ $t('global.until') }}&nbsp;<strong>{{
                    Math.min(filteredItems.length, currentPage * perPage)
                  }}</strong
                  >&nbsp;{{ $t('global.from') }}&nbsp;<strong>{{ filteredItems.length }}</strong
                  >&nbsp;{{ $t('global.text.entries') }}.
                </p>
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows == null ? rows : totalRows"
                  :per-page="perPage"
                >
                </b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal form for Add & Edit User -->
    <b-modal
      class="mc-modal"
      id="modal-form-user"
      :title="isEdit ? $t('master.form.user.updateUser') : $t('master.form.user.addUser')"
      size="lg"
      centered
      scrollable
      @hidden="resetModal"
      @ok="handleOk"
      footer-class="d-flex justify-content-between"
    >
      <div class="card-body mc-modal__filter p-2">
        <form @submit.stop.prevent="handleSubmit">
          <div class="mb-2">
            <label class="required">{{ $t('master.form.user.type') }}</label>
            <b-form-radio plain value="true" v-model="form.isEmployee" disabled
              >Karyawan</b-form-radio
            >
          </div>
          <div class="mb-2">
            <label class="mt-3 required">{{ $t('master.form.user.name') }}</label>
            <multiselect
              v-model="form"
              :options="cannotLoginUsers"
              placeholder="Nama"
              label="fullname"
              :class="{
                'is-invalid': $v.form.fullname.$error,
              }"
              group-values="users"
              group-label="department"
              :group-select="false"
              @input="setUsernameDefault"
              v-if="!isEdit"
            >
            </multiselect>
            <b-form-input
              placeholder="Nama"
              v-model="form.fullname"
              disabled
              v-if="isEdit"
            ></b-form-input>

            <div v-if="$v.form.fullname.$error" class="invalid-feedback">
              <span v-if="!$v.form.fullname.required"> Nama Wajib Terisi </span>
            </div>
          </div>
          <div class="mb-2">
            <label>{{ $t('master.form.user.group') }}</label>
            <multiselect
              ref="groupOptions"
              v-model="form.groups"
              :options="ugroups.ugroups"
              :placeholder="`${$t('global.form.select')} ${$t('master.form.user.group')}`"
              label="name"
              @input="changeGroup"
              track-by="name"
            >
            </multiselect>
          </div>
          <div class="mb-2">
            <label class="required">Email</label>
            <b-form-input placeholder="Email" v-model="form.email" disabled></b-form-input>
          </div>
          <div class="mb-2">
            <label class="required">Username</label>
            <b-form-input placeholder="Username" v-model="form.username" :class="{
                'is-invalid': $v.form.fullname.$error,
              }"></b-form-input>
            <div v-if="$v.form.username.$error" class="invalid-feedback d-block">
              <span v-if="!$v.form.username.required"> Username wajib terisi. </span>
            </div>
          </div>
          <div class="mb-2">
            <label class="required">{{ $t('master.form.user.password') }}</label>

            <!-- For password not using bootstrap form group for show / hide password -->
            <div
              class="input-group auth-pass-inputgroup"
              :class="{
                'is-invalid': $v.form.password.$error,
              }"
            >
              <input
                :type="isPasswordShow ? 'text' : 'password'"
                v-model="form.password"
                class="form-control"
                :placeholder="`${$t('global.form.enter')} ${$t('master.form.user.password')}`"
                aria-label="Password"
                aria-describedby="password-addon"
                autocomplete="off"
              />
              <button
                class="btn btn-light btn-eye"
                type="button"
                id="password-addon"
                @click="showPassword"
              >
                <i :class="showPasswordIcon"></i>
              </button>
            </div>
            <div v-if="$v.form.password.$error" class="invalid-feedback">
              <span v-if="!$v.form.password.required"> Kata sandi wajib terisi. </span>
              <span v-if="!$v.form.password.minLength"> Kata sandi minimal 4 karakter. </span>
              <span v-if="!$v.form.password.maxLength"> Kata sandi maksimal 50 karakter. </span>
            </div>
          </div>
        </form>
      </div>
      <template #modal-footer="{ cancel }">
        <div></div>
        <div>
          <b-button variant="outline-primary" @click="cancel()" class="me-3"> {{ $t('global.cancel') }} </b-button>
          <b-button variant="primary" @click="handleOk"> {{ $t('global.save') }} </b-button>
        </div>
      </template>
    </b-modal>

    <!-- Modal for Delete Confirmation -->
    <b-modal
      class="mc-modal"
      id="modal-delete-user"
      title="Hapus"
      size="md"
      centered
      scrollable
      @hidden="resetModal"
      @ok="handleOk"
    >
      <div class="card-body mc-modal__filter p-2">
        <p>Apakah Anda yakin menghapus data berikut?</p>
        <b-list-group>
          <b-list-group-item v-for="user in deleteUser" :key="user.userId"
            >{{ user.email }}
          </b-list-group-item>
        </b-list-group>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel()" class="me-2"> Tidak </b-button>
            <b-button @click="toDelete" variant="primary"> Ya </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </Layout>
</template>
